'use strict';

import $ from 'jquery';
import { initOnboarding } from '@/js/modules/onboarding';
import { toggleDiscussionPanel } from '@/js/application/messages';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#project')) {
      $(document).on('submit', '.accept-project-form', (e) => {
        const $submit = $(e.target).find('button[type=submit]');
        $submit.addClass('button-loading').prop('disabled', true);

        return true;
      });
    } else if ($('body').is('#projects-dashboard')) {
      if ($('.onboarding-steps-container').data('auto-play') === true) {
        initOnboardingDashboard();
      }
    }

    if ($('.modal--client-bookmark').length) {
      $('.modal--client-bookmark').modal();
    }

    // Check wat OS client uses and modify modal content accordingly
    if (navigator.userAgent.includes('Mac OS X')) {
      $('.modal--client-bookmark__button-text')
        .html('')
        .addClass('modal--client-bookmark__button-text--mac');
      $('.modal--client-bookmark__button--ctrl')
        .removeClass('.modal--client-bookmark__button--ctrl')
        .addClass('modal--client-bookmark__button--cmd');
    }
  });

  function initOnboardingDashboard() {
    const config = {
      stepOptions: [
        { element: '#project-details', position: 'right' },
        { element: '#contact-details', position: 'bottom' },
        { element: '#project-notes', position: 'left' },
        { element: '#requires-follow-up', position: 'top' },
        { element: '#design-boards', position: 'top' },
        { element: '#financial-summary', position: 'top' },
      ],
    };

    let panelClosed = 0;
    initOnboarding({
      stepOptions: config.stepOptions,
      onStart() {
        if ($('.discussion-panel').hasClass('discussion-panel--active')) {
          toggleDiscussionPanel(false, true);
          panelClosed = 1;
        }
      },
      onBeforeChange() {},
      onComplete() {
        if (panelClosed === 1) {
          toggleDiscussionPanel(true);
        } else {
          toggleDiscussionPanel(false);
        }
        window.scrollTo(0, 0);
      },
    });
  }

  $(document).on('click', '.p-button--sortable-board-list-save', () => {
    const boardId = parseInt($('meta[name=board-id]').attr('content'));
    const fpViewId = parseInt($('meta[name=fp-view-id]').attr('content'));
    let combinedId;
    if (!Number.isNaN(boardId)) {
      combinedId = `board-${boardId}`;
    } else if (!Number.isNaN(fpViewId)) {
      combinedId = `fpview-${fpViewId}`;
    }

    const projectId = $('.sortable-board-list').data().projectId;
    const combinedIds = $('.sortable-board-list__item')
      .map((_, el) => {
        return $(el).data().combinedId;
      })
      .get();

    $.post(`/projects/${projectId}/xhr_reorder_boards`, { combined_ids: combinedIds }).then(() => {
      window.location.reload();
    });

    const prevId = combinedIds[combinedIds.indexOf(combinedId) - 1];
    const nextId = combinedIds[combinedIds.indexOf(combinedId) + 1];

    if (prevId) {
      const href = $(`.sortable-board-list__item[data-combined-id="${prevId}"]`).data().url;
      $('.pagination-link--prev, .top-board-nav__prev').removeClass('hide').attr('href', href);
    } else {
      $('.pagination-link--prev, .top-board-nav__prev').addClass('hide');
    }
    if (nextId) {
      const href = $(`.sortable-board-list__item[data-combined-id="${nextId}"]`).data().url;
      $('.pagination-link--next, .top-board-nav__next').removeClass('hide').attr('href', href);
    } else {
      $('.pagination-link--next, .top-board-nav__next').addClass('hide');
    }

    $('.top-board-nav__field').val(`${combinedIds.indexOf(combinedId) + 1}`);

    combinedIds.forEach((combinedId) => {
      const board = $('.boards-list').find(`.boards-list__board[data-id="${combinedId}"]`);
      $('.boards-list').append(board);
    });

    $.modal.close();

    return false;
  });

  $(document).on('click', '.dropdown-menu__link--dashboard-walkthrough', (e) => {
    e.preventDefault();
    initOnboardingDashboard();
  });
});
